<div class="searchBg">
  <input type="text" class="form-control ellipsis" [ngClass]="Classes"
    [id]="LocationSelectionId" [name]="LocationSelectionName" placeholder="{{PlaceHolder}}"
    [(ngModel)]="SearchKeywordLocation" 
    (input)="OnInput($event)"  
    (keydown)="OnkeyDown($event)" 
    (paste)="OnPasteText($event)"
    on-change="OnSearchLocationChange()"
    (click)="DisplayAutoCompleteResult()"
    autocomplete="off" />
    <span *ngIf="ReadCurrentLocation" class="target-icon" title="Get Current Location"><i class="fas fa-crosshairs" (click)="OnClickGpsTargetIcon()"></i></span>
</div>

<div *ngIf="IsSuggest && AutoCompleteOptions">
  <div class="opt">
    <ul class="list-group" id="autocompletelist">
      <li class="list-group-item" *ngFor="let op of AutoCompleteOptions;let i=index;"
        [class.autocompleteactive]="i == ArrowkeyLocation" (click)="OnOptionSelected(op)">
        <!-- <span *ngIf="op?.Key != '0'"><i class="fas fa-location-arrow"></i></span>  -->
        {{op.DisplayValue}}
      </li>
    </ul>
  </div>
</div>